import {NgClass} from "@angular/common"
import {Component, input, ChangeDetectionStrategy} from "@angular/core"
import {TestCaseEntry} from "@app/test/manual-testing/helpers/configurator-test-helpers"
import {MatTooltipModule} from "@angular/material/tooltip"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-test-button",
    templateUrl: "./test-button.component.html",
    styleUrls: ["./test-button.component.scss"],
    imports: [MatTooltipModule, NgClass],
})
export class TestButtonComponent {
    readonly $entry = input.required<TestCaseEntry>({alias: "entry"})
}
